
import { Options, Vue } from "vue-class-component";
import { isNewBridgeView } from '@/assets/js/utils'
import { doJump } from "@/utils/nativeFn";

@Options({
  props: {
    source: {
      type: String,
      default: 'recommendList',
    },
  },
})
export default class CloseRecommend extends Vue {
  // 去设置智能推荐开关页面
  goSetRecommendStatus() {
    if (isNewBridgeView()) {
      let path = '10003'
      doJump(path, () => {
        console.log("跳转成功");
      })
      return
    }
    let data = {
      url: 'xueersi://com.tal.publish.book/10003'
    }
    window['$mobileNativeSDK'].doJump(data);
  }
}
